<template>
    <v-container class="pa-5" fluid>
        <page-title>
            Prepress
        </page-title>

        <v-row>
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card
                                class="mx-auto fill-height"
                            >
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-chart-line
                                    </v-icon>
                                    Raport wykonanych płyt
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Raport wykonanych płyt
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        @click="openReport('reportingAndAnalysisPrepressReportPlates')"
                                    >
                                        Otwórz
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-card
                                class="mx-auto fill-height"
                            >
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-chart-line
                                    </v-icon>
                                    Raport płyt dodatkowych
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Raport płyt dodatkowych
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        @click="openReport('reportingAndAnalysisPrepressReportAdditionalPlates')"
                                    >
                                        Otwórz
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import PageTitle from '@/components/common/PageTitle'
import { errorHandler } from '@/utils/errorHandler'
export default {
    name: 'Prepress',
    components: {
        PageTitle,
    },
    methods: {
        openReport(report) {
            this.$router.push({name: report})
                .catch(error => {
                    // eslint-disable-next-line no-undef
                    errorHandler(error)
                })
        },
    }
}
</script>